var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 44,
    viewBox: "0 0 132 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9142 19.9978C46.0223 19.9978 42.8673 23.1528 42.8673 27.0447C42.8673 30.9367 46.0223 34.0917 49.9142 34.0917C53.8061 34.0917 56.9612 30.9367 56.9612 27.0447C56.9612 23.1528 53.8061 19.9978 49.9142 19.9978ZM33.5965 27.0447C33.5965 18.0327 40.9022 10.7271 49.9142 10.7271C58.9262 10.7271 66.2319 18.0327 66.2319 27.0447C66.2319 36.0567 58.9262 43.3624 49.9142 43.3624C40.9022 43.3624 33.5965 36.0567 33.5965 27.0447ZM86.2348 19.9978C82.3429 19.9978 79.1879 23.1528 79.1879 27.0447C79.1879 30.9367 82.3429 34.0917 86.2348 34.0917C90.1267 34.0917 93.2818 30.9367 93.2818 27.0447C93.2818 23.1528 90.1267 19.9978 86.2348 19.9978ZM69.9171 27.0447C69.9171 18.0327 77.2228 10.7271 86.2348 10.7271C95.2468 10.7271 102.552 18.0328 102.552 27.0447C102.552 36.0567 95.2468 43.3624 86.2348 43.3624C77.2228 43.3624 69.9171 36.0567 69.9171 27.0447ZM0 43.3624L0 10.7271H9.27071V22.5142H21.0225V10.7271H30.2932V43.3624H21.0225V31.7849H9.27071V43.3624H0Z",
    fill: "#3475F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.634 11.3647L104.109 11.3647V20.6354H113.237V44H122.508V20.6354H131.637V11.3647L123.111 11.3647C122.55 13.2656 120.417 14.68 117.873 14.68C115.328 14.68 113.196 13.2656 112.634 11.3647Z",
    fill: "#3475F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.873 0L126.905 4.78488L117.873 9.56977L108.84 4.78488L117.873 0Z",
    fill: "#3475F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.d1f3b369958250a8c22662b6d5ce585e.svg";
export { ForwardRef as ReactComponent };